/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { updateAlbumNameModelSchema } from "../updateAlbumNameModelSchema.ts";
import { z } from "zod";

export const patchApiAlbumsIdNamePathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор альбома")
    })

/**
 * @description Трек добавлен
 */
export const patchApiAlbumsIdName200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const patchApiAlbumsIdName400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const patchApiAlbumsIdName401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const patchApiAlbumsIdName403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Альбом не найден
 */
export const patchApiAlbumsIdName404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const patchApiAlbumsIdName500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const patchApiAlbumsIdNameMutationRequestSchema = z.lazy(() => updateAlbumNameModelSchema).describe("Тело запроса")

export const patchApiAlbumsIdNameMutationResponseSchema = z.lazy(() => patchApiAlbumsIdName200Schema)